import { createStore } from 'effector';

export interface AppState {
  language: string;
  sessionId: string;
  from: string;
}

export const initialAppState: AppState = {
  language: 'en',
  sessionId: '',
  from: '',
};

export const $app = createStore(initialAppState);

export const $language = $app.map((app) => app.language);
